<div class="mainTemlateDiv">
    <iframe class="templateIframe" [src]="embedURL" allow="clipboard-read; clipboard-write" width='100%'></iframe>
</div>